import { render, staticRenderFns } from "./ResourceFields.vue?vue&type=template&id=379b45dc&lang=pug&"
import script from "./ResourceFields.vue?vue&type=script&lang=js&"
export * from "./ResourceFields.vue?vue&type=script&lang=js&"
import style0 from "./ResourceFields.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports